import { render, staticRenderFns } from "./MetaSendCapiEvent.vue?vue&type=template&id=02be2960&scoped=true"
import script from "./MetaSendCapiEvent.vue?vue&type=script&lang=js"
export * from "./MetaSendCapiEvent.vue?vue&type=script&lang=js"
import style0 from "./MetaSendCapiEvent.vue?vue&type=style&index=0&id=02be2960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02be2960",
  null
  
)

export default component.exports